import Router from "./router";
import PageRenderer from "./pages/PageRenderer";
import { useInitialPage } from "./hooks/useInitialPage";

import { Spin } from "antd";

const FullscreenLoader = () => {
  return (
    <div className="h-screen flex flex-col items-center justify-center gap-4 bg-deepco-surface-white">
      <img
        src="/Logo-Symbol.png"
        alt="Deepco"
        style={{ width: '10vw', height: 'auto' }}
      />
      <Spin />
      <span className="text-sm text-deepco-neutral-300">
        Loading your space…
      </span>
    </div>
  );
};

const RootApp = () => {
  const { pageId, loading } = useInitialPage();

  if (loading) {
    return <FullscreenLoader />;
  }

  if (pageId) {
    return <PageRenderer pageId={pageId} />;
  }

  return <Router />;
};

export default RootApp;
